export const resolveMathdownImagePath = (path: string) => {
  if (process.env.NEXT_PUBLIC_FB_STORAGE_BUCKET === undefined)
    throw new Error('missing NEXT_PUBLIC_FB_STORAGE_BUCKET')
  const IMAGE_PREFIX = `https://firebasestorage.googleapis.com/v0/b/${process.env.NEXT_PUBLIC_FB_STORAGE_BUCKET}/o`
  const IMAGE_SUFFIX = '?alt=media'

  return `${IMAGE_PREFIX}${path.replace(/(?!^)\//g, '%2F')}${IMAGE_SUFFIX}`
}
